import React, { useEffect, useState } from "react";
import { Route, Switch } from "react-router";
import Footer from "../Components/Footer/footer";
import Header from "../Components/Header/header";
import Sidebar from "../Components/Sidebar/sidebar";
import SplashScreen from "../Components/SplashScreen/splashScreen";
import About from "../Containers/About/about";
import Blog from "../Containers/Blog/blog";
import ChooseIssue from "../Containers/ChooseIssue/chooseIssue";
import Coming from "../Containers/Coming/coming";
import Contact from "../Containers/Contact/contact";
import CustomerProfile from "../Containers/CustomerProfile/customerProfile";
import FAQ from "../Containers/FAQ/faq";
import Guideline from "../Containers/Guideline/guideline";
import Home from "../Containers/Home/home";
import OrderHistory from "../Containers/OrderHistory/orderHistory";
import OrderTracking from "../Containers/OrderTracking/orderTracking";
import Partner from "../Containers/Partner/partner";
import Privacy from "../Containers/Privacy/privacy";
import SMS from "../Containers/SMS/sms";
import Terms from "../Containers/Terms/terms";

const PublicRoutes = () => {
  return (
    <div className="main-box">
      <Header />
      <div className="main-body">
        {/* <Sidebar /> */}
        <Switch>
          <Route path="/terms" component={Terms} />
          <Route path="/privacy-policy" component={Privacy} />
          <Route path="/choose-issue" component={ChooseIssue} />
          <Route path="/coming" component={Coming} />
          <Route path="/sms-policy" component={SMS} />
          <Route path="/guideline" component={Guideline} />
          <Route path="/faq" component={FAQ} />
          <Route path="/partner" component={Partner} />
          <Route path="/blog" component={Blog} />
          <Route path="/about" component={About} />
          <Route path="/contact" component={Contact} />
          <Route exact path="/" component={Home} />
        </Switch>
      </div>

      {/* please don't remove comment it's important */}
      {/* <div className="color-box">
        <div className="container">
          <div className="customer-box">
            <Sidebar />
            <div className="customer-home">
              <Switch>
                <Route path="/order-tracking" component={OrderTracking} />
                <Route path="/order-history" component={OrderHistory} />
                <Route path="/" component={CustomerProfile} />
              </Switch>
            </div>
          </div>
        </div>
      </div> */}
      <Footer />
    </div>
  );
};

export default PublicRoutes;
